import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';
import { Metamodel } from 'app/model/base/model';
import { OracleFusionTableDataset } from 'app/model/dataset/oracle-fusion.dataset';
import { OracleFusionLinkedService } from 'app/model/linkedservice/oracle-fusion.linkedservice';
import { GlobalVariables } from 'app/services/globals';

export const oracleFusionTableMetadata: IDatasetTypeMetadata = {
    type: Metamodel.modelFor(OracleFusionTableDataset).name,
    displayName: stringResources.OracleFusion_DisplayText,
    disabled: !GlobalVariables.enableOracleFusionConnector,
    supportLinkedServiceTypes: [Metamodel.modelFor(OracleFusionLinkedService).name],
    isSource: true,
    isSink: false,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-Oracle'
    },
    isFirstClass: true,
    supportCreatedAsV2: true,
    notSupportPhysicalType: true,
    notSupportCopySourceQuery: true,
    category: ['ServicesApps'],
    isTableRequired: true,
    splitTablePath: true,
    schemaAlias: 'schema',
    tableAlias: 'table'
};